import { jsx as _jsx } from "react/jsx-runtime";
import { Selector, Util } from 'ui-lib';
import * as React from 'react';
var Status;
(function (Status) {
    Status["Active"] = "ACTIVE";
    Status["Deleted"] = "DELETED";
})(Status || (Status = {}));
export function StatusSelector(props) {
    var choices = Util.idNamePairsFromEnum(Status);
    return _jsx(Selector, { name: props.name, items: choices, label: "Status" });
}
